<script>
  import {Line} from 'vue-chartjs'

  export default {
    extends: Line,
    props: ['dataset', 'options'],
    data: () => ({
      htmlLegend: null
    }),
    mounted (){
      this.renderChart(this.dataset, this.options)
/*      name: {
        type: String,
        default: function(){
          return ''
        }
      },
      showCharts: Boolean,
    },
    created (){
      this.$emit('showCharts')
    },
    watch: {
      showCharts: function () {
        this.renderChart(this.chartsData, this.options)
      }
    }*/
  }
}
</script>